import {
    MPESA_STK
} from './actionTypes'
const mpesaStk = ({paymentItem, phoneNumber, amount}) => ({
    type: MPESA_STK,
    payload: {
        paymentItem, phoneNumber, amount
    },
    errors: null
});

export{
    mpesaStk
}